const initialState = {
    
};

export const actionCreators = {
    
}

export const reducer = (state, action) => {
    state = state || initialState;

    return state;
}


// WEBPACK FOOTER //
// ./src/store/NavMenu.js